
const terminalUtility = require('../domain/terminalUtility');
const stringUtil = require('../string/stringUtil');

module.exports.mapSecurityCode = function(code)
{
    if(!terminalUtility.isRunningUnderAndroidShell())
        return stringUtil.replaceAll(code, " ", "");

    return mapFromAndroidCodeFormat(code);
}

function mapFromAndroidCodeFormat(code)
{
    //Example
    //  Input: d4 ff 6a cb
    //  Transformed: cb6affd4
    //  Output: 3412787156

    const hexWords = code.split(" ");

    let hexCode = "";
    for(let index = hexWords.length -1 ; index >= 0; index--)
    {
        hexCode += hexWords[index];
    }

    const decimal = `${parseInt(hexCode, 16)}`;
    return decimal;
}